var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVehicleMarkerCalloutNay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "m88.86,223.91l147.43,-73.71l-123.43,-18.86l-73.71,32.57l49.71,60z",
    id: "svg_76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.12,18.39l158.91,0l0,163.33l-158.91,0l0,-163.33z",
    id: "svg_80"
  }), /*#__PURE__*/React.createElement("clip-path", {
    id: "svg_71"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#svg_80",
    id: "svg_79",
    y: 1046.403882,
    x: 771.505425
  }))), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_186"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    transform: "matrix(0.5916399560687641,0,0,0.5916399560687641,-248.58513635137837,-249.66622749402023) ",
    id: "svg_184"
  }, /*#__PURE__*/React.createElement("title", {
    stroke: "null",
    transform: "translate(422.8427429199219,0) translate(0,422.8427429199219) "
  }, "background"), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    x: 421.842743,
    y: 421.842743,
    width: 252,
    height: 252,
    id: "svg_182",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    transform: "matrix(0.5916399560687641,0,0,0.5916399560687641,-248.58513635137837,-249.66622749402023) ",
    id: "svg_185"
  }, /*#__PURE__*/React.createElement("title", {
    stroke: "null",
    transform: "translate(422.8427429199219,0) translate(0,422.8427429199219) "
  }, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_167"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_168"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_177"
  }, /*#__PURE__*/React.createElement("use", {
    stroke: "null",
    x: 422.842743,
    y: 422.842743,
    xlinkHref: "#svg_180",
    fill: "#b1b1b1",
    id: "svg_181"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_178"
  }, /*#__PURE__*/React.createElement("use", {
    stroke: "#b1b1b1",
    x: 422.842743,
    y: 422.842743,
    xlinkHref: "#svg_180",
    fillOpacity: 0,
    id: "svg_179"
  }))), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_172"
  }, /*#__PURE__*/React.createElement("use", {
    stroke: "null",
    x: 422.842743,
    y: 422.842743,
    xlinkHref: "#svg_175",
    fill: "#808080",
    id: "svg_176"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_173"
  }, /*#__PURE__*/React.createElement("use", {
    stroke: "#b1b1b1",
    x: 422.842743,
    y: 422.842743,
    xlinkHref: "#svg_175",
    fillOpacity: 0,
    id: "svg_174"
  }))), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_169"
  }, /*#__PURE__*/React.createElement("use", {
    stroke: "null",
    x: 422.842743,
    y: 422.842743,
    xlinkHref: "#svg_171",
    fill: "#ffffff",
    id: "svg_170"
  })))))), /*#__PURE__*/React.createElement("path", {
    d: "m25.906027,-6.351166c-0.540543,0 -0.265511,1.277946 5.405388,8.648628c12.407692,16.126755 27.80336,30.760628 41.621536,49.729622c13.770439,18.903465 23.333313,36.397461 32.9729,54.05394c6.371048,11.669632 10.644333,22.038757 12.972946,29.72966c1.937531,6.399216 2.318146,10.739594 3.243225,12.972946c1.308273,3.158447 1.081085,4.864853 1.621628,6.486465l0.540543,1.081085",
    id: "svg_97",
    strokeWidth: 1.5,
    stroke: "null",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(41.79258346557617 74.99998474121091,75) ",
    id: "svg_98",
    height: 158.378034,
    width: 9.729709,
    y: -4.189022,
    x: 70.135139,
    strokeWidth: 1.5,
    stroke: "null",
    fill: "#ff0000"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "svg_140",
    d: "m244.18,161.48l-0.19,0.29l-0.25,0.35l-0.27,0.34l-0.27,0.33l-0.3,0.32l-0.3,0.31l-0.32,0.3l-0.33,0.29l-0.35,0.27l-0.36,0.27l-0.37,0.24l-0.38,0.24l-0.4,0.22l-0.41,0.21l-107.24,51.92l-0.42,0.19l-0.42,0.17l-0.42,0.15l-0.43,0.14l-0.42,0.12l-0.43,0.1l-0.43,0.08l-0.44,0.07l-0.43,0.04l-0.43,0.03l-0.43,0.02l-0.43,-0.01l-0.43,-0.02l-0.43,-0.03l-0.43,-0.06l-0.42,-0.06l-0.42,-0.09l-0.41,-0.1l-0.41,-0.12l-0.41,-0.13l-0.4,-0.15l-0.39,-0.16l-0.39,-0.18l-0.38,-0.19l-0.37,-0.21l-0.37,-0.22l-0.36,-0.24l-0.35,-0.25l-0.34,-0.26l-0.33,-0.28l-0.32,-0.29l-0.31,-0.31l-0.29,-0.32l-0.29,-0.33l-0.28,-0.34l-0.26,-0.36l-0.25,-0.37l-0.23,-0.39l-0.23,-0.39l-0.2,-0.41l-30.06,-62.1l-0.2,-0.41l-0.17,-0.42l-0.15,-0.43l-0.14,-0.42l-0.12,-0.43l-0.1,-0.43l-0.08,-0.43l-0.06,-0.43l-0.05,-0.44l-0.03,-0.43l-0.02,-0.43l0.01,-0.43l0.02,-0.43l0.03,-0.43l0.06,-0.42l0.07,-0.42l0.08,-0.42l0.1,-0.42l0.12,-0.41l0.13,-0.4l0.15,-0.4l0.16,-0.4l0.18,-0.38l0.19,-0.39l0.21,-0.37l0.22,-0.37l0.24,-0.35l0.25,-0.35l0.26,-0.34l0.28,-0.33l0.29,-0.32l0.31,-0.31l0.32,-0.3l0.33,-0.29l0.35,-0.27l0.35,-0.27l0.37,-0.25l0.39,-0.23l0.39,-0.22l0.41,-0.21l107.25,-51.92l0.41,-0.19l0.42,-0.17l0.43,-0.16l0.42,-0.13l0.43,-0.12l0.43,-0.1l0.43,-0.08l0.43,-0.07l0.44,-0.04l0.43,-0.03l0.43,-0.02l0.43,0.01l0.43,0.02l0.35,0.03l-0.71,-1.47l39.64,5.72l39.64,5.73l-20.1,34.63l-20.1,34.64l0,0l-0.05,-0.09z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_136",
    d: "m229.66,120.05c0.61,4.32 -2.41,8.33 -6.73,8.94c-4.33,0.61 -8.33,-2.41 -8.94,-6.73c-0.61,-4.33 2.4,-8.33 6.73,-8.94c4.32,-0.61 8.33,2.4 8.94,6.73z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_132",
    d: "m78.83,216l147.43,-73.71l-123.43,-18.86l-73.71,32.57l49.71,60z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_144",
    d: "m19.09,10.48l158.91,0l0,163.33l-158.91,0l0,-163.33z"
  }), /*#__PURE__*/React.createElement("clip-path", {
    id: "svg_127"
  }, /*#__PURE__*/React.createElement("use", {
    id: "svg_143",
    xlinkHref: "#svg_144",
    y: 674.408354,
    x: 637.132195
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "m189.49,158.99l-0.19,0.29l-0.25,0.35l-0.27,0.34l-0.28,0.33l-0.29,0.32l-0.3,0.31l-0.32,0.3l-0.34,0.29l-0.34,0.27l-0.36,0.27l-0.37,0.25l-0.38,0.23l-0.4,0.22l-0.41,0.21l-107.24,51.92l-0.42,0.19l-0.42,0.17l-0.42,0.16l-0.43,0.13l-0.43,0.12l-0.43,0.1l-0.43,0.08l-0.43,0.07l-0.43,0.05l-0.43,0.03l-0.44,0.01l-0.43,0l-0.43,-0.02l-0.42,-0.04l-0.43,-0.05l-0.42,-0.07l-0.42,-0.09l-0.41,-0.1l-0.41,-0.12l-0.41,-0.13l-0.4,-0.15l-0.39,-0.16l-0.39,-0.18l-0.38,-0.19l-0.37,-0.21l-0.37,-0.22l-0.36,-0.24l-0.35,-0.25l-0.34,-0.26l-0.33,-0.28l-0.32,-0.29l-0.31,-0.31l-0.3,-0.32l-0.28,-0.33l-0.28,-0.34l-0.26,-0.36l-0.25,-0.37l-0.24,-0.39l-0.22,-0.39l-0.21,-0.41l-30.06,-62.1l-0.19,-0.41l-0.17,-0.42l-0.15,-0.43l-0.14,-0.42l-0.12,-0.43l-0.1,-0.43l-0.08,-0.43l-0.07,-0.43l-0.04,-0.44l-0.03,-0.43l-0.02,-0.43l0.01,-0.43l0.02,-0.43l0.03,-0.43l0.06,-0.42l0.06,-0.42l0.09,-0.42l0.1,-0.42l0.12,-0.41l0.13,-0.4l0.15,-0.4l0.16,-0.4l0.18,-0.38l0.19,-0.38l0.21,-0.38l0.22,-0.36l0.24,-0.36l0.25,-0.35l0.26,-0.34l0.28,-0.33l0.29,-0.32l0.31,-0.31l0.32,-0.3l0.33,-0.29l0.34,-0.27l0.36,-0.26l0.37,-0.25l0.39,-0.24l0.39,-0.22l0.41,-0.21l107.25,-51.92l0.41,-0.19l0.42,-0.17l0.42,-0.15l0.43,-0.14l0.43,-0.12l0.43,-0.1l0.43,-0.08l0.43,-0.07l0.43,-0.04l0.44,-0.03l0.43,-0.02l0.43,0.01l0.43,0.02l0.35,0.03l-0.71,-1.47l39.64,5.72l39.63,5.73l-20.09,34.64l-20.1,34.63l0,0l-0.05,-0.09z",
    id: "svg_180"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m91.28,65.48l50.31,-41.36l-50.31,147.88l-52.45,-147.88l52.45,41.36z",
    id: "svg_175"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m174.96,117.56c0.61,4.32 -2.4,8.33 -6.73,8.94c-4.32,0.61 -8.33,-2.41 -8.94,-6.73c-0.6,-4.33 2.41,-8.33 6.74,-8.94c4.32,-0.61 8.33,2.41 8.93,6.73z",
    id: "svg_171"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleMarkerCalloutNay);
export default __webpack_public_path__ + "static/media/vehicleMarkerCallout_Nay.a19f2973ec3cc75dd01cab54a794546b.svg";
export { ForwardRef as ReactComponent };